module.exports = __webpack_public_path__ + "static/media/bookmark_unstocked.a4b3bad0.svg";